import React from "react";
import styled from "styled-components";
// Components
import FullButton from "../Buttons/FullButton";
import AnimateOnScroll from "../AnimateOnScroll";
// Assets
import HeaderImage from "../../assets/img/home-426x607.jpg";
import QuotesIcon from "../../assets/svg/Quotes";
import Dots from "../../assets/svg/Dots";

export default function Header() {
  return (
    <Wrapper id="home">
      <BackgroundElements>
        <GradientOrb orb1 />
        <GradientOrb orb2 />
        <GradientOrb orb3 />
        <PatternDots />
      </BackgroundElements>
      
      <div className="container">
        <HeroSection>
          <LeftSide className="flexCenter">
            <AnimateOnScroll animation="fadeRight" delay={0} duration={1000}>
              <div>
                <h1 className="extraBold font60">
                  Transform Your <span className="gradient-text">Academic Journey</span>
                </h1>
                <h2 className="font30 semiBold">Academic Foundation for Rising Intellectuals in Africa</h2>
                <HeaderP className="semiBold">
                  AFRIQ helps students study the right way, understand key concepts, and prepare effectively for competitive entrance exams into universities and professional schools. 
                  We provide structured concours preparation supported by expert teaching, academic orientation, and career mentorship to equip students with the knowledge, skills, and guidance needed to succeed.
                </HeaderP>
                <AnimateOnScroll animation="scaleUp" delay={300} duration={800}>
                  <StatsRow className="flexSpaceCenter">
                    <StatItem>
                      <StatNumber className="extraBold gradient-text">500+</StatNumber>
                      <StatLabel>Students Prepared</StatLabel>
                    </StatItem>
                    <StatItem>
                      <StatNumber className="extraBold gradient-text">85%</StatNumber>
                      <StatLabel>Success Rate</StatLabel>
                    </StatItem>
                    <StatItem>
                      <StatNumber className="extraBold gradient-text">2</StatNumber>
                      <StatLabel>Specialized Wings</StatLabel>
                    </StatItem>
                  </StatsRow>
                </AnimateOnScroll>
                <AnimateOnScroll animation="fadeUp" delay={500} duration={800}>
                  <BtnWrapper>
                    <div className="btnCol">
                      <FullButton title="Apply for AFRIQ PREPA" to="/apply" />
                    </div>
                    <div className="btnCol">
                      <FullButton title="Join as Tutor" border />
                    </div>
                  </BtnWrapper>
                </AnimateOnScroll>
              </div>
            </AnimateOnScroll>
          </LeftSide>
          <RightSide>
            <AnimateOnScroll animation="fadeLeft" delay={200} duration={1000}>
              <ImageWrapper>
                <ImgContainer>
                  <Img className="radius8" src={HeaderImage} alt="AFRIQ Students" />
                  <ImageOverlay />
                </ImgContainer>
                <AnimateOnScroll animation="bounceIn" delay={600} duration={800}>
                  <QuoteWrapper className="flexCenter darkBg radius8">
                    <QuotesWrapper>
                      <QuotesIcon />
                    </QuotesWrapper>
                    <div>
                      <p className="font15 whiteColor">
                        <em>"At AFRIQ, we believe that every student possesses the potential for greatness when given the right guidance, structure, and mentorship. We are committed to nurturing minds, shaping character, and inspiring futures one student at a time."</em>
                      </p>
                      <p className="font13 goldColor textRight" style={{marginTop: '10px'}}>— AFRIQ</p>
                    </div>
                  </QuoteWrapper>
                </AnimateOnScroll>
                <DotsWrapper>
                  <Dots />
                </DotsWrapper>
              </ImageWrapper>
            </AnimateOnScroll>
          </RightSide>
        </HeroSection>
      </div>
      
      <FeaturesSection>
        <div className="container">
          <FeaturesGrid>
            <AnimateOnScroll animation="fadeUp" delay={0} duration={800}>
              <FeatureCard>
                <FeatureIcon className="gradient-bg">
                  <span className="font20 whiteColor">📚</span>
                </FeatureIcon>
                <h4 className="font18 extraBold purpleColor">Comprehensive Study Materials</h4>
                <p className="font13 blackColor" style={{opacity: 0.8}}>Textbooks, workbooks, and past questions for thorough preparation</p>
              </FeatureCard>
            </AnimateOnScroll>
            <AnimateOnScroll animation="fadeUp" delay={200} duration={800}>
              <FeatureCard>
                <FeatureIcon className="gradient-bg">
                  <span className="font20 whiteColor">👥</span>
                </FeatureIcon>
                <h4 className="font18 extraBold purpleColor">Expert Mentorship</h4>
                <p className="font13 blackColor" style={{opacity: 0.8}}>Guidance from experienced professionals and successful alumni</p>
              </FeatureCard>
            </AnimateOnScroll>
            <AnimateOnScroll animation="fadeUp" delay={400} duration={800}>
              <FeatureCard>
                <FeatureIcon className="gradient-bg">
                  <span className="font20 whiteColor">🎓</span>
                </FeatureIcon>
                <h4 className="font18 extraBold purpleColor">Scholarship Opportunities</h4>
                <p className="font13 blackColor" style={{opacity: 0.8}}>Financial support to make quality education accessible</p>
              </FeatureCard>
            </AnimateOnScroll>
          </FeaturesGrid>
        </div>
      </FeaturesSection>
    </Wrapper>
  );
}


const Wrapper = styled.section`
  padding-top: 80px;
  width: 100%;
  position: relative;
  background: #4b2e83;
  font-family: 'Montserrat', sans-serif;
  min-height: 100vh;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: 
      radial-gradient(circle at 20% 80%, rgba(75, 46, 131, 0.4) 0%, transparent 50%),
      radial-gradient(circle at 80% 20%, rgba(75, 46, 131, 0.3) 0%, transparent 50%),
      radial-gradient(circle at 40% 40%, rgba(75, 46, 131, 0.2) 0%, transparent 50%);
    z-index: 1;
  }
`;

const BackgroundElements = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  pointer-events: none;
`;

const GradientOrb = styled.div`
  position: absolute;
  border-radius: 50%;
  backdrop-filter: blur(10px);
  animation: float 6s ease-in-out infinite;
  
  ${props => props.orb1 && `
    width: 300px;
    height: 300px;
    top: 10%;
    left: -10%;
    animation-delay: 0s;
    background: linear-gradient(135deg, rgba(75, 46, 131, 0.2) 0%, rgba(75, 46, 131, 0.1) 100%);
    border: 2px solid rgba(75, 46, 131, 0.3);
  `}
  
  ${props => props.orb2 && `
    width: 200px;
    height: 200px;
    top: 60%;
    right: -5%;
    animation-delay: 2s;
    background: linear-gradient(135deg, rgba(75, 46, 131, 0.2) 0%, rgba(75, 46, 131, 0.1) 100%);
    border: 2px solid rgba(75, 46, 131, 0.3);
  `}
  
  ${props => props.orb3 && `
    width: 150px;
    height: 150px;
    top: 30%;
    right: 20%;
    animation-delay: 4s;
    background: linear-gradient(135deg, rgba(75, 46, 131, 0.2) 0%, rgba(75, 46, 131, 0.1) 100%);
    border: 2px solid rgba(75, 46, 131, 0.3);
  `}
  
  @keyframes float {
    0%, 100% { transform: translateY(0px) rotate(0deg); }
    50% { transform: translateY(-20px) rotate(180deg); }
  }
`;

const PatternDots = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: 
    radial-gradient(circle at 1px 1px, rgba(255, 255, 255, 0.15) 1px, transparent 0);
  background-size: 20px 20px;
  animation: moveDots 20s linear infinite;
  
  @keyframes moveDots {
    0% { transform: translate(0, 0); }
    100% { transform: translate(20px, 20px); }
  }
`;

const HeroSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  min-height: 85vh;
  gap: 80px;
  position: relative;
  z-index: 3;
  opacity: 0;
  transform: translateY(30px);
  animation: heroEntrance 1.2s ease-out 0.3s forwards;
  padding: 60px 0;
  
  @media (max-width: 1200px) {
    gap: 60px;
  }
  
  @media (max-width: 960px) {
    grid-template-columns: 1fr;
    gap: 30px;
    min-height: auto;
    padding: 30px 0 20px 0;
  }
  
  @media (max-width: 480px) {
    gap: 20px;
    padding: 20px 0 15px 0;
  }
  
  @keyframes heroEntrance {
    0% {
      opacity: 0;
      transform: translateY(30px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const StatsRow = styled.div`
  margin: 60px 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  opacity: 0;
  transform: translateY(30px);
  animation: statsEntrance 1s ease-out 1s forwards;
  width: 100%;
  
  @media (max-width: 960px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin: 40px 0;
  }
  
  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    gap: 25px;
    margin: 30px 0;
  }
  
  @media (max-width: 480px) {
    gap: 20px;
    margin: 25px 0;
  }
  
  @keyframes statsEntrance {
    0% {
      opacity: 0;
      transform: translateY(30px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const StatItem = styled.div`
  text-align: center;
  padding: 40px 30px;
  background: rgba(75, 46, 131, 0.25);
  backdrop-filter: blur(25px);
  border-radius: 20px;
  border: 2px solid rgba(255, 255, 255, 0.35);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  width: 100%;
  
  @media (max-width: 960px) {
    padding: 30px 20px;
    border-radius: 16px;
  }
  
  @media (max-width: 640px) {
    padding: 35px 25px;
  }
  
  @media (max-width: 480px) {
    padding: 30px 20px;
  }
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.25), transparent);
    transition: left 0.6s ease;
  }
  
  &:hover {
    background: rgba(75, 46, 131, 0.35);
    transform: translateY(-15px) scale(1.05);
    box-shadow: 0 30px 70px rgba(255, 255, 255, 0.3);
    
    &::before {
      left: 100%;
    }
  }
  
  @media (max-width: 1200px) {
    min-width: 220px;
    max-width: 300px;
    padding: 50px 40px;
  }
  
  @media (max-width: 960px) {
    min-width: 200px;
    max-width: 280px;
    padding: 45px 35px;
  }
  
  @media (max-width: 560px) {
    min-width: 100%;
    max-width: 100%;
    padding: 40px 30px;
  }
`;

const StatNumber = styled.div`
  margin-bottom: 15px;
  font-size: clamp(2.5rem, 6vw, 4.5rem);
  line-height: 1;
  font-weight: 900;
  
  @media (max-width: 480px) {
    margin-bottom: 10px;
  }
`;

const StatLabel = styled.div`
  color: rgba(255, 255, 255, 1);
  font-weight: 800;
  font-size: clamp(0.9rem, 2vw, 1.4rem);
  line-height: 1.2;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  
  @media (max-width: 480px) {
    letter-spacing: 0.3px;
  }
`;

const FeaturesSection = styled.div`
  padding: 100px 0;
  margin-top: 80px;
  position: relative;
  z-index: 3;
  opacity: 0;
  transform: translateY(50px);
  animation: featuresEntrance 1.2s ease-out 1.4s forwards;
  
  @media (max-width: 768px) {
    padding: 60px 0;
    margin-top: 40px;
  }
  
  @keyframes featuresEntrance {
    0% {
      opacity: 0;
      transform: translateY(50px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  
  @media (max-width: 960px) {
    grid-template-columns: 1fr;
    gap: 30px;
  }
`;

const FeatureCard = styled.div`
  background: #ffffff;
  padding: 35px 25px;
  border-radius: 16px;
  text-align: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(75, 46, 131, 0.1);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  color: #333;
  
  @media (max-width: 768px) {
    padding: 30px 20px;
    border-radius: 14px;
  }
  
  @media (max-width: 480px) {
    padding: 25px 18px;
    border-radius: 12px;
  }
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(75, 46, 131, 0.05) 0%, rgba(75, 46, 131, 0.05) 100%);
    opacity: 0;
    transition: opacity 0.4s ease;
  }
  
  &:hover {
    transform: translateY(-15px) scale(1.02);
    box-shadow: 0 25px 60px rgba(75, 46, 131, 0.2);
    background: #ffffff;
    
    &::before {
      opacity: 1;
    }
  }
  
  &:nth-child(1) {
    animation-delay: 0.1s;
  }
  
  &:nth-child(2) {
    animation-delay: 0.2s;
  }
  
  &:nth-child(3) {
    animation-delay: 0.3s;
  }
`;

const FeatureIcon = styled.div`
  width: 70px;
  height: 70px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  background: #4b2e83;
  box-shadow: 0 8px 25px rgba(75, 46, 131, 0.3);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.2) 50%, transparent 70%);
    transform: translateX(-100%);
    transition: transform 0.6s ease;
  }
  
  &:hover {
    transform: scale(1.15) rotate(8deg);
    box-shadow: 0 15px 40px rgba(75, 46, 131, 0.4);
    
    &::before {
      transform: translateX(100%);
    }
  }
  
  span {
    color: #ffffff !important;
  }
`;

const LeftSide = styled.div`
  width: 100%;
  height: 100%;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  
  h1, h2, p {
    color: white;
  }
  
  h1 {
    font-size: clamp(2rem, 5vw, 3.75rem);
    line-height: 1.2;
    margin-bottom: 20px;
  }
  
  h2 {
    font-size: clamp(1.25rem, 3vw, 1.875rem);
    margin-bottom: 20px;
  }
  
  @media (max-width: 960px) {
    order: 2;
    margin: 0;
    text-align: center;
    padding: 20px 0;
  }
  
  @media (max-width: 480px) {
    padding: 15px 0;
    
    h1 {
      line-height: 1.1;
      margin-bottom: 15px;
    }
    
    h2 {
      margin-bottom: 15px;
    }
  }
`;

const RightSide = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  
  @media (max-width: 960px) {
    display: none;
  }
`;

const HeaderP = styled.div`
  max-width: 520px;
  padding: 20px 0 40px 0;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.95);
  font-size: clamp(1rem, 2vw, 1.2rem);
  font-weight: 400;
  
  @media (max-width: 960px) {
    padding: 15px 0 35px 0;
    text-align: center;
    max-width: 100%;
    font-size: 1.15rem;
  }
  
  @media (max-width: 560px) {
    font-size: 1.1rem;
    line-height: 1.7rem;
  }
`;

const BtnWrapper = styled.div`
  display: flex;
  gap: 16px;
  max-width: 380px;
  margin-top: 20px;
  opacity: 0;
  transform: translateY(20px);
  animation: buttonsEntrance 0.8s ease-out 1.2s forwards;

  .btnCol {
    width: 48%;
    transition: all 0.3s ease;
    
    &:hover {
      transform: translateY(-2px);
    }
  }

  @media (max-width: 960px) {
    flex-direction: column;
    max-width: 100%;
    margin: 0 auto;
    gap: 12px;

    .btnCol {
      width: 100%;
    }
  }
  
  @keyframes buttonsEntrance {
    0% {
      opacity: 0;
      transform: translateY(20px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const ImageWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  position: relative;
  z-index: 9;
  opacity: 0;
  transform: translateX(50px);
  animation: imageEntrance 1.2s ease-out 0.8s forwards;
  
  @media (max-width: 960px) {
    width: 100%;
    max-width: 100%;
    justify-content: center;
  }
  
  @keyframes imageEntrance {
    0% {
      opacity: 0;
      transform: translateX(50px);
    }
    100% {
      opacity: 1;
      transform: translateX(0);
    }
  }
`;

const ImgContainer = styled.div`
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  width: 100%;
  max-width: 500px;
  
  @media (max-width: 960px) {
    max-width: 100%;
    max-height: 300px;
    border-radius: 12px;
  }
  
  @media (max-width: 768px) {
    max-height: 250px;
    border-radius: 10px;
  }
  
  @media (max-width: 480px) {
    max-height: 200px;
    border-radius: 8px;
  }
  
  &:hover {
    transform: scale(1.02) rotate(1deg);
    box-shadow: 0 30px 80px rgba(0, 0, 0, 0.4);
    
    @media (max-width: 960px) {
      transform: none;
    }
  }
`;

const Img = styled.img`
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
  
  @media (max-width: 960px) {
    max-height: 300px;
    object-fit: cover;
    object-position: center;
  }
  
  @media (max-width: 768px) {
    max-height: 250px;
  }
  
  @media (max-width: 480px) {
    max-height: 200px;
  }
`;

const ImageOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(75, 46, 131, 0.2) 0%, rgba(75, 46, 131, 0.2) 100%);
  pointer-events: none;
`;

const QuoteWrapper = styled.div`
  position: absolute;
  left: 0;
  bottom: 50px;
  max-width: 330px;
  padding: 30px;
  z-index: 99;
  background: rgba(75, 46, 131, 0.95);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  opacity: 0;
  transform: translateY(30px);
  animation: quoteEntrance 1s ease-out 1.6s forwards;
  transition: all 0.3s ease;
  
  @media (max-width: 960px) {
    display: none;
  }
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);
  }
  
  @media (max-width: 960px) {
    left: 20px;
  }
  @media (max-width: 560px) {
    bottom: -50px;
  }
  
  @keyframes quoteEntrance {
    0% {
      opacity: 0;
      transform: translateY(30px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const QuotesWrapper = styled.div`
  position: absolute;
  left: -20px;
  top: -10px;
`;

const DotsWrapper = styled.div`
  position: absolute;
  right: -100px;
  bottom: 100px;
  z-index: 2;
  @media (max-width: 960px) {
    right: 100px;
  }
  @media (max-width: 560px) {
    display: none;
  }
`;


